import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography} from "@material-ui/core";
import React, {useState} from "react";

export const otherEntityUrl = (e) => {
    switch (e.entity_type) {
        case 'RIA': return `/admin/live_data/ria_investors?investor_id=${e.crd_id}`;
        case 'FO':  return `/admin/investors?data_type=fintrx_data&investor_id=${e.entity_id}`;
        case 'BT':  return `/admin/live_data/bt_firms?bank_trust_id=${e.entity_id}`;
        default:    return `/admin/foundation_firms?foundation_id=${e.entity_id}`;
    }
};

const otherEntityTypeLabel = (e) => {
    switch (e.entity_type) {
        case 'RIA': return `RIA${e.crd_id ? ` · CRD #${e.crd_id}` : ''}`;
        case 'FO':  return 'Family Office';
        case 'BT':  return 'Bank + Trust';
        default:    return 'Endowment + Foundation';
    }
};

// Shared "Other Entities" button + inline list + management popup, used on both the B+T and FO
// sidebars. `canRemove` lets a caller hide the REMOVE button for entity types it doesn't own the
// relationship for (e.g. the FO side can't remove its BT link — that lives on the BT record).
const OtherEntitiesManager = ({ ownerName, entities, canRemove = () => true, onRemove }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [removingKey, setRemovingKey] = useState(null);

    if (!entities?.length) return null;

    return (
        <div className="info-item" style={{alignItems: 'flex-start'}}>
            <button
                type="button"
                style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit', textAlign: 'left'}}
                onMouseEnter={e => { e.currentTarget.style.textDecoration = 'underline'; e.currentTarget.style.color = '#1a56db'; }}
                onMouseLeave={e => { e.currentTarget.style.textDecoration = 'none'; e.currentTarget.style.color = ''; }}
                onClick={() => setDialogOpen(true)}
            >
                Other Entities
            </button>
            <span>
                {entities.map((e, i) => (
                    <span key={`${e.entity_type}-${e.entity_id}`}>
                        {i > 0 && <span style={{color: '#ccc'}}> · </span>}
                        <Link href={otherEntityUrl(e)} target="_blank" rel="noopener noreferrer">
                            {e.name}
                        </Link>
                    </span>
                ))}
            </span>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle disableTypography style={{padding: '24px 24px 0'}}>
                    <Typography style={{fontWeight: 700, fontSize: 20}}>Same entities</Typography>
                </DialogTitle>
                <DialogContent style={{padding: '12px 24px 0'}}>
                    <Typography variant="body2" style={{color: '#444', marginBottom: 20}}>
                        The entities below are those that are marked as the same as <strong>{ownerName}</strong>.
                    </Typography>
                    <div style={{borderTop: '1px solid #eeeeee'}}>
                        {entities.map(e => {
                            const key = `${e.entity_type}-${e.entity_id}`;
                            const isRemoving = removingKey === key;
                            return (
                                <div key={key} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid #eeeeee'}}>
                                    <div>
                                        <Link href={otherEntityUrl(e)} target="_blank" rel="noopener noreferrer" style={{fontWeight: 600, fontSize: 15, color: '#1a56db'}}>
                                            {e.name}
                                        </Link>
                                        <Typography variant="caption" display="block" style={{color: '#666', marginTop: 2, fontSize: 12}}>
                                            {otherEntityTypeLabel(e)}
                                        </Typography>
                                    </div>
                                    {canRemove(e) &&
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            disabled={isRemoving}
                                            style={{color: '#c62828', borderColor: '#c62828', fontWeight: 700, fontSize: 12, letterSpacing: 0.5, minWidth: 90}}
                                            onClick={async () => {
                                                setRemovingKey(key);
                                                try {
                                                    const stillOpen = await onRemove(e);
                                                    if (stillOpen === false) setDialogOpen(false);
                                                } catch (err) {
                                                    console.error('Failed to remove entity relationship', err);
                                                } finally {
                                                    setRemovingKey(null);
                                                }
                                            }}
                                        >
                                            {isRemoving ? '...' : 'REMOVE'}
                                        </Button>
                                    }
                                </div>
                            );
                        })}
                    </div>
                </DialogContent>
                <DialogActions style={{padding: '12px 24px 20px', justifyContent: 'flex-end'}}>
                    <Button onClick={() => setDialogOpen(false)} variant="outlined" color="primary" size="small" style={{fontWeight: 700, fontSize: 13, letterSpacing: 0.5, minWidth: 80}}>
                        DONE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default OtherEntitiesManager;
